import { _, allRoles, isAuthorized, lazyLoadView, piloteAndAuditor } from '@/router/routing'
import type { Route, RouteConfig } from 'vue-router'
import { CAMPAIGN_RESULTS_ROUTE } from '@/contexts/campaigns/Campaigns.constants'

export const campaignsRoutes: RouteConfig = {
  path: '/campaigns',
  name: 'campaign',
  component: () => lazyLoadView(import('@/contexts/campaigns/CampaignsView.vue')),
  meta: {
    title: _('Evaluations'),
    icon: 'check-square',
    is_authorized: (route: Route) => isAuthorized(route),
    requires_auth: true,
    requires_tenant: true,
    requires_role: piloteAndAuditor,
    doc_id: 'campaign',
    feature_id: 'CAMPAIGNS',
  },
  children: [
    {
      path: 'results/:campaign_id/:perimeter_id?',
      name: CAMPAIGN_RESULTS_ROUTE,
      component: () => lazyLoadView(import('@/contexts/campaigns/CampaignDetailsView.vue')),
      meta: {
        title: null,
        is_authorized: (route: Route) => isAuthorized(route),
        requires_auth: true,
        requires_tenant: true,
        requires_role: piloteAndAuditor,
        doc_id: 'campaign_details',
      },
      children: [
        {
          path: 'eval-details',
          name: 'campaign_eval_details',
          component: () => lazyLoadView(import('@/contexts/campaigns/CampaignEvalView.vue')),
          meta: {
            title: null,
            is_authorized: (route: Route) => isAuthorized(route),
            requires_auth: true,
            requires_tenant: true,
            requires_role: allRoles,
            challenge_mode: true,
            doc_id: 'campaign_eval_details',
          },
        },
      ],
    },
  ],
}
